(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const seen = new WeakSet();
  const load = (img) => {
    const picture = img.closest('picture');
    picture?.querySelectorAll('source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({isIntersecting, target}) => {
      if (!isIntersecting) return;
      load(target);
      observer.unobserve(target);
    });
  }, {rootMargin: '900px 0px'}) : null;
  const scan = (node) => {
    const images = [];
    if (node.matches?.('img.ww-emergency-image[data-src]')) images.push(node);
    node.querySelectorAll?.('img.ww-emergency-image[data-src]').forEach((img) => images.push(img));
    images.forEach((img) => {
      if (seen.has(img)) return;
      seen.add(img);
      if (observer) observer.observe(img); else load(img);
    });
  };
  scan(root);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scan));
  }).observe(root, {childList: true, subtree: true});
})();
